// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".family-search-header__function__save-workspace .elstc-btn{padding:0 8px;height:24px;line-height:24px;margin-right:12px}.family-search-header__function__save-workspace .elstc-btn:hover{background-color:rgba(179,186,197,.2)}.family-search-header__function__save-workspace .eb-pre-text{display:inline-block;font-size:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
